import { render } from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=template&id=629e6e12&scoped=true"
import script from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeAddDependantOnboardComponent.vue?vue&type=style&index=0&id=629e6e12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629e6e12"]])

export default __exports__